


































import Vue from 'vue';
import { Component, Model } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { ChatGptInstruction } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { getDepartmentListHeaders } from '@/views/admin/department/department';
import { departmentService, storeService } from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    Stores: () => import('@/components/common/store.select.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
})
export default class ChatGptInstructions extends Base {
  public headers: VHeaders[] = [
    {
      align: 'left',
      sortable: true,
      text: 'Rule Order',
      value: 'orderDescription',
    },
    {
      align: 'left',
      sortable: true,
      text: 'Status',
      // value: 'isDefaultTemplate',
      fieldType: 'template',
      template: (item) => {
        if (item.isEnabled == true) {
          return `<span style="color:green;">Enabled</span>`;
        }
        else {
          return `<span style="color:red;">Disabled</span>`;
        }
      }
    },
    {
      align: 'left',
      sortable: true,
      text: 'Instruction',
      value: 'template',
    },
    {
      align: 'center',
      sortable: false,
      isNotDataProp: true,
      text: 'Actions',
      value: '',
    },
  ];
  public chatGptInstructions: any[] = []; //Department[] = [];
  public pagination = new PaginationModel('name');
  public loading: boolean = false;
  public storeId: number;
  public actions: any[] = [];
  public isInstructionExists: boolean = false;

  public deleteDialog: IDialogOption = {
    width: 400,
    title: 'Delete ChatGPT Instruction',
    model: false,
    loading: false,
    action: { color: 'success', icon: 'fas fa-check', text: 'Agree', disable: false },
    onAction: (): void => {
      this.deleteChatGptInstruction();
    },
  };

  public updateRuleOrderDialog: IDialogOption = {
    width: 400,
    title: 'Confirm?',
    model: false,
    loading: false,
    action: { color: 'success', icon: 'fas fa-check', text: 'Agree', disable: false },
    onAction: (): void => {
      this.UpdateChatGptInstructionRuleOrder();
    },
  };
  public chatGptInstructionToDelete = {
    id: '',
    template: '',
    storeId: 0,
  };

  public chatGptRuleOrderToUpdate = {
    id: '',
    template: '',
    storeId: 0,
    ruleOrder: 0,
    isDefaultTemplate: false,
    isEnabled: false,
    sequenceNumber: 0
  };

  public preventPaginationCall: boolean = false;
  public setActions() {
    this.actions = [
      {
        type: 'button',
        icon: 'fas fa-arrow-down',
        title: 'Order Desc',
        color: 'primary',
        visible: (model: any) => {
          return this.IsShowRuleOrderBtnDesc(model.ruleOrder);
        },
        action: (model: any) => {
          this.ConfirmUpdateRuleOrder(this.storeId, model, true);
        },
      },
      {
        type: 'button',
        icon: 'fas fa-arrow-up',
        title: 'Order Asc',
        color: 'primary',
        visible: (model: any) => {
          if (model.ruleOrder <= 1)
            return false;
          else
            return true;
        },
        action: (model: any) => {
          this.ConfirmUpdateRuleOrder(this.storeId, model, false);
        },
      },
      {
        type: 'link',
        icon: 'fas fa-edit',
        title: 'Edit',
        color: 'primary',
        visible: true,
        action: (model: any) => {
          return {
            name: 'admin.chatgpt.edit',
            params: {
              storeId: this.storeId,
              id: model.id,
            },
          };
        },
      },
      {
        type: 'button',
        icon: 'fas fa-trash-alt',
        title: 'Delete',
        color: 'error',
        action: (model, storeId: string) => {
          this.confirmDelete(model);
        },
      },
    ];
  }

  public created() {
    if (this.$route.params.storeId) {
      this.storeId = Number(this.$route.params.storeId);
    } else {
      this.storeId = this.userSession.storeId;
    }
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'addChatGptInstruction') {
      this.$router.push({
        name: 'admin.chatgpt.add',
        params: { storeId: this.storeId.toString() },
      });
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: 'Add ChatGPT Instruction',
      disabled: false,
      visible: !this.isInstructionExists,
      class: 'btn',
      label: 'Add ChatGPT Instruction',
      click: 'addChatGptInstruction',
      icon: 'fas fa-plus-circle',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'chatGptInstructions');

    // Toolbar
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.storeId = this.userSession.storeId;
    this.setActions();
  }

  public async getChatGptInstructions(storeId: number): Promise<void> {
    try {
      this.loading = true;
      var chatGptInstructions = await storeService.getChatGptInstructions(
        storeId
      );
      this.pagination.totalItems = chatGptInstructions.total;
      this.chatGptInstructions = chatGptInstructions.results;
    } finally {

      this.sortRules();
      // if (chatGptInstructions && chatGptInstructions.total > 0) {
      //   this.isInstructionExists = true;
      //   const buttons = [];
      //   this.$emit('updateToolBar', buttons);
      // } else {
      //   this.isInstructionExists = false;
      //   this.updateToolBar();
      // }
      this.updateToolBar();
      this.loading = false;
    }
  }

  public sortRules() {
    this.chatGptInstructions.sort((a, b) => {
      if (a.ruleOrder < b.ruleOrder) {
        // sort string ascending
        return -1;
      }
      if (a.ruleOrder > b.ruleOrder) {
        return 1;
      }
    });
  }

  public updatePaging(paging: any) {
    //   this.pagination = paging;
  }

  public confirmDelete(item: any): void {
    this.deleteDialog.model = true;
    this.chatGptInstructionToDelete = item;
  }

  public async deleteChatGptInstruction(): Promise<void> {
    try {
      this.deleteDialog.loading = true;
      this.deleteDialog.action.disable = true;
      await storeService.DeleteChatGptInstruction(
        this.storeId,
        this.chatGptInstructionToDelete.id
      );
      //this.preventPaginationCall = true;
      this.showAlert(true, 'Instruction Deleted successfully');
      this.getChatGptInstructions(this.storeId);
    } catch (e) {
      console.log(e);
    } finally {
      this.deleteDialog.loading = false;
      this.deleteDialog.action.disable = false;
      this.deleteDialog.model = false;
    }
  }


  public ConfirmUpdateRuleOrder(storeId: number, item: any, sequenceNumber: boolean): void {
    this.updateRuleOrderDialog.model = true;
    this.chatGptRuleOrderToUpdate.storeId = storeId;
    this.chatGptRuleOrderToUpdate.id = item.id;
    this.chatGptRuleOrderToUpdate.ruleOrder = item.ruleOrder;
    this.chatGptRuleOrderToUpdate.sequenceNumber = sequenceNumber ? 1 : -1;
  }

  public async UpdateChatGptInstructionRuleOrder(): Promise<void> {
    try {
      this.updateRuleOrderDialog.loading = true;
      this.updateRuleOrderDialog.action.disable = true;

      await storeService.updateChatGptRuleOrder(
        this.chatGptRuleOrderToUpdate.storeId,
        this.chatGptRuleOrderToUpdate.id,
        this.chatGptRuleOrderToUpdate.ruleOrder,
        this.chatGptRuleOrderToUpdate.sequenceNumber,
      );
      //this.preventPaginationCall = true;
      this.showAlert(true, 'Rule Order updated successfully');
      this.getChatGptInstructions(this.storeId);
    } catch (e) {
      console.log(e);
    } finally {
      this.updateRuleOrderDialog.loading = false;
      this.updateRuleOrderDialog.action.disable = false;
      this.updateRuleOrderDialog.model = false;
    }
  }

  public updateStore(storeId: number): void {
    this.storeId = storeId;
    this.getChatGptInstructions(this.storeId);
  }

  public IsShowRuleOrderBtnDesc(ruleOrder: number) {
    if (ruleOrder < 0) {
      return false;
    } else {
      if (this.chatGptInstructions[this.chatGptInstructions.length - 1].ruleOrder == ruleOrder) {
        return false;
      } else {
        return true;
      }
    }
  }
}
